import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ExcelqueandansRoutingModule } from './excelqueandans-routing.module';
import { ExcelUploadComponent } from './excel-upload/excel-upload.component';
import { ExcelqandaService } from './excelqanda.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'app/shared/shared.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LlmService } from 'app/services/llm.service';
import { StaffRoomService } from '../staff-room/staff-room.service';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from "primeng/tooltip";


@NgModule({ declarations: [
        ExcelUploadComponent
    ], imports: [CommonModule, FormsModule,
        ReactiveFormsModule, SharedModule,
        DropdownModule,
        ExcelqueandansRoutingModule,
        TooltipModule], providers: [ExcelqandaService, LlmService, StaffRoomService, provideHttpClient(withInterceptorsFromDi())] })
export class ExcelqueandansModule { }
